import {Injectable} from '@angular/core';
import {State} from '../model/state.model';
import {StateService} from '../service/state.service';

@Injectable()
export class StateInteractor {
    private readonly stateService: StateService;

    constructor(stateService: StateService) {
        this.stateService = stateService;
    }

    async getAll(): Promise<State[]> {
        return await this.stateService.getAll();
    }
}
